import { render, staticRenderFns } from "./SpecialPriceDetails_Details.vue?vue&type=template&id=7a1a196a&"
import script from "./SpecialPriceDetails_Details.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports